var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessVerification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#DCFCE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3337 15.2335V16.0002C24.3326 17.7972 23.7507 19.5458 22.6748 20.9851C21.5988 22.4244 20.0864 23.4773 18.3631 23.9868C16.6399 24.4963 14.798 24.4351 13.1124 23.8124C11.4267 23.1896 9.98754 22.0386 9.00946 20.5311C8.03138 19.0236 7.56682 17.2403 7.68506 15.4471C7.80329 13.654 8.498 11.9472 9.66556 10.5811C10.8331 9.21506 12.411 8.26303 14.1638 7.867C15.9167 7.47097 17.7505 7.65216 19.392 8.38355",
    stroke: "#16A34A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15.1663L16 17.6663L24.3333 9.33301",
    stroke: "#16A34A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessVerification);
export default __webpack_public_path__ + "static/media/Business Verification.2557af1f3085be20993a6f305a3e7ebb.svg";
export { ForwardRef as ReactComponent };